export default "__VITE_ASSET__CCuexBmm__"